<template>
  <v-card class="pa-5">
    <v-toolbar dark color="primary" dense class="mb-5">
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Documento</v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <v-form ref="form">
      <v-row justify="center" no-gutters class="mt-10">
        <v-col cols="12" md="3" class="d-flex justify-center">
          <v-checkbox v-model="document.active" label="Ativo?" />
        </v-col>
      </v-row>

      <v-row justify="center" no-gutters>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="document.title"
            :counter="100"
            outlined
            dense
            label="Título do Documento *"
            :rules="$rules.required"
            required
          />
        </v-col>
      </v-row>

      <v-row justify="center" no-gutters>
        <v-col cols="12" md="6">
          <v-file-input
            v-model="attcUpload"
            label="Clique para adicionar um arquivo *"
            outlined
            show-size
            accept="application/pdf,application/vnd.ms-excel"
            :rules="attcUrl ? [] : $rules.required"
            :required="attcUrl ? false : true"
          >
            <template #selection="{ text }">
              <v-chip class="white accent-4" label>
                {{ text }}
              </v-chip>
            </template>
          </v-file-input>

          <div v-if="attcUrl" class="mt-2 mr-1">
            <v-icon small class="mr-1">mdi-paperclip</v-icon>
            <a :href="attcUrl" target="_blank" rel="noopener noreferrer"> Ver documento atual </a>
          </div>
        </v-col>
      </v-row>
    </v-form>

    <v-row class="mt-10" justify="center" no-gutters>
      <v-card-actions>
        <v-btn color="secondary" @click="close"> Cancelar </v-btn>
        <v-btn v-if="loading === true" color="primary" loading @click="submit" />
        <v-btn v-else color="primary" @click="submit"> Salvar </v-btn>
      </v-card-actions>
    </v-row>
  </v-card>
</template>

<script>
import MeetingDocumentsService from "../../../services/meeting-documents.service";
import { image } from "../../../services/upload-service";

export default {
  name: "MeetingDocumentsForm",
  props: {
    populateWith: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      document: {
        id: null,
        active: false,
        title: null,
        url: null,
        s3Key: null,
      },
      attcUpload: null,
      attcUrl: null,
      loading: false,
    };
  },
  async created() {
    if (this.populateWith.id) {
      this.document = { ...this.populateWith };
      this.attcUpload = null;
      this.attcUrl = this.populateWith.url;
    }
  },
  methods: {
    close() {
      this.clearForm();
      this.$emit("close-dialog");
    },

    async checkFileAndUpload() {
      if (this.attcUpload) {
        const uploadedLink = await image(this.attcUpload);

        const url = uploadedLink[0];

        const s3Key = url.split("/").pop();

        this.document = { ...this.document, url, s3Key };
      }
    },

    async updateDocument() {
      try {
        this.loading = true;

        await this.checkFileAndUpload();

        await MeetingDocumentsService.updateDocument({ ...this.document });

        this.$emit("document-edited", this.document);
        this.$toast.success("Documento editado com sucesso!");
        this.close();
      } catch (e) {
        this.$handleHttpError(e);
      } finally {
        this.loading = false;
      }
    },

    async submit() {
      if (!this.$refs.form.validate()) {
        this.$toast.error("Verifique os campos e tente novamente");
        return;
      }

      if (this.document.id) {
        await this.updateDocument();
        return;
      }

      try {
        this.loading = true;

        await this.checkFileAndUpload();

        await MeetingDocumentsService.createDocument({ ...this.document });

        this.$emit("document-added", { ...this.document });

        this.clearForm();
        this.$toast.success("Artigo cadastrado com sucesso");
        this.close();
      } catch (e) {
        this.$handleHttpError(e);
      } finally {
        this.loading = false;
      }
    },

    clearForm() {
      this.$refs.form.reset();
      this.document.id = null;
      this.document.active = false;
      this.document.title = null;
      this.document.url = null;
      this.document.s3Key = null;
      this.attcUpload = null;
      this.attcUrl = null;
      this.$refs.form.resetValidation();
    },
  },
};
</script>
